import { useEffect, useState } from 'react';

let showAlert = null;

export default function AlertPopup() {

    const [popup, setPopup] = useState({
        open: false,
        message: ''
    });

    useEffect(() => {

        showAlert = (message) => {
            setPopup({
                open: true,
                message: String(message ?? '')
            });
        };

        // const originalAlert = window.alert;

        window.betShareAlert = (message) => {
            showAlert?.(message);
        };

        // return () => {
        //     window.alert = originalAlert;
        // };

    }, []);

    if (!popup.open) {
        return null;
    }

    return (
        <div style={styles.overlay}>
            <div style={styles.dialog}>

                <div style={styles.title}>
                    This page says
                </div>

                <div style={styles.content}>
                    {popup.message}
                </div>

                <div style={styles.footer}>
                    <button
                        style={styles.button}
                        onClick={() =>
                            setPopup({
                                open: false,
                                message: ''
                            })}
                    >
                        OK
                    </button>
                </div>

            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999999
    },

    dialog: {
        width: '320px',
        background: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow:
            '0 4px 20px rgba(0,0,0,.25)'
    },

    title: {
        padding: '14px 16px',
        fontWeight: 600,
        borderBottom: '1px solid #ddd',
        fontSize: '14px'
    },

    content: {
        padding: '20px 16px',
        minHeight: '60px',
        wordBreak: 'break-word',
        fontSize: '14px'
    },

    footer: {
        borderTop: '1px solid #ddd',
        textAlign: 'right'
    },

    button: {
        border: 'none',
        background: 'transparent',
        color: '#0067c0',
        padding: '12px 18px',
        cursor: 'pointer',
        fontWeight: 600
    }
};